import React from 'react';

export const Impressum = () => {
  return (
    <div className="content-wrapper">
      <h1>Impressum</h1>
      <p>Grillmeister</p>

      <h2>Kontakt</h2>
      <p>E-Mail: office@grillmeister.de</p>

      <h1>Haftungshinweis</h1>
      <p>
        {' '}
        Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung
        für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten
        sind ausschließlich deren Betreiber verantwortlich.
      </p>
    </div>
  );
};
